/* eslint-disable import/prefer-default-export */

import requests from '@webclient/lib/agent/requests';
import axiosApiInstance from '@webclient/lib/agent/services/api/axiosInstance';

import {
  BotResponseType,
  BotsRequestType,
  BotsResponseType,
  CreateMinimalBotRequestType,
  GetBotByIdResponseType,
  UpdateBotRequestType,
} from '@webclient/shared-types/bots';

export const bots = {
  getAll: (body: BotsRequestType) =>
    requests(axiosApiInstance).get<BotsResponseType>('v1/entities/bots', {
      params: body,
    }),
  createOne: (body: CreateMinimalBotRequestType) =>
    requests(axiosApiInstance).post<BotResponseType>('v1/entities/bots', body),
  updateOne: ({ id, body }: { id: number; body: UpdateBotRequestType }) =>
    requests(axiosApiInstance).patch<BotResponseType>(
      `v1/entities/bots/${id}`,
      body,
    ),
  deleteOne: (id: number) =>
    requests(axiosApiInstance).delete<BotResponseType>(
      `v1/entities/bots/${id}`,
    ),
  getOne: (id: number) =>
    requests(axiosApiInstance).get<GetBotByIdResponseType>(
      `v1/entities/bots/${id}`,
    ),
};
